/**
 * Admin System Settings API Client
 * Currently exposes the Demo Mode switch (UAT only).
 */

import axios from '@/lib/api/axios-instance'

const BASE = '/api/admin/settings'

export interface DemoModeSetting {
  /** Server env ALLOW_DEMO_MODE=true - demo mode can only be switched on when this is true */
  allowed: boolean
  /** Effective state: allowed AND switched on */
  enabled: boolean
}

interface ApiResponse<T> {
  success: boolean
  data: T
}

export async function getDemoModeSetting(): Promise<DemoModeSetting> {
  const res = await axios.get<ApiResponse<DemoModeSetting>>(`${BASE}/demo-mode`)
  return res.data.data
}

export async function setDemoModeSetting(enabled: boolean): Promise<DemoModeSetting> {
  const res = await axios.put<ApiResponse<DemoModeSetting>>(`${BASE}/demo-mode`, { enabled })
  return res.data.data
}
